module.exports = __webpack_public_path__ + "static/img/partner-rp.a685ba3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-rp.png
// module id = bAa1
// module chunks = 34